export const SET_SYSTEM_SETTINGS = 'SET_SYSTEM_SETTINGS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_ASSIGNED_VEHICLES_COUNT = 'SET_ASSIGNED_VEHICLES_COUNT';
export const SET_VEHICLES_WITH_LOCATION_COUNT = 'SET_VEHICLES_WITH_LOCATION_COUNT';
export const LOGOUT = 'LOGOUT';
export const SET_REALTIME_SOCKET = 'SET_REALTIME_SOCKET';
export const CLEAR_REALTIME_SOCKET = 'CLEAR_REALTIME_SOCKET';
export const AUTHORIZE = 'AUTHORIZE';
